import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { CustomAppNameField, validateAppName } from './CustomAppNameField';

export const CustomAppNameFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'CustomAppNameField',
    component: CustomAppNameField,
    validation: validateAppName, // This enables form-level validation that blocks navigation
  }),
);